import { Auth0Provider } from '@auth0/auth0-react';
import { Progress } from 'src/components/progress/Progress';
import { useGetEnvironment } from 'src/hooks/api';

import { AuthProvider as AuthDataProvider } from '../authProvider';
import { AuthProps } from './Auth.interface';

export const AuthProvider = (props: AuthProps) => {
  const { isLoading, data: environment } = useGetEnvironment();

  if (isLoading) {
    return <Progress />;
  }

  if (
    !environment?.auth0.clientId ||
    !environment.auth0.domain ||
    !environment.hq
  ) {
    throw new Error('Missing environment variables');
  }

  const onRedirectCallback = (appState?: { returnTo?: string }) => {
    // Clean the URL and land on either saved returnTo or default app root
    const target = `/#${appState?.returnTo ?? '/'}`;
    window.history.replaceState({}, document.title, target);
  };

  return (
    <Auth0Provider
      clientId={environment.auth0.clientId}
      domain={environment.auth0.domain}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: environment.hq,
      }}
      onRedirectCallback={onRedirectCallback}>
      <AuthDataProvider environment={environment}>
        {props.children}
      </AuthDataProvider>
    </Auth0Provider>
  );
};
